export default "__VITE_ASSET__aGbdSBkQ__"